angular.module('unica_invitation_transfer.invitation_transfer_services')

.factory('InvitationTransferDeleteService', function ($http, getBaseApiURL) {

	var invitationTransferDeleteService = {};

	invitationTransferDeleteService.delete = function (invitationTransferId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-transfer/delete/' + invitationTransferId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return invitationTransferDeleteService;
});